module.exports = __webpack_public_path__ + "img/template_icon.87b3b8b7.png";